var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5216 32.2933L23.0395 4.16937C22.4124 3.09133 21.2474 2.42188 20 2.42188C18.7526 2.42188 17.5876 3.09133 16.9627 4.16828L0.478359 32.2933C0.164766 32.83 0 33.4411 0 34.0625C0 36.0011 1.57703 37.5781 3.51562 37.5781H36.4844C38.423 37.5781 40 36.0011 40 34.0625C40 33.4411 39.8352 32.83 39.5216 32.2933ZM20 30.5469C19.3528 30.5469 18.8281 30.0222 18.8281 29.375C18.8281 28.7277 19.3528 28.2031 20 28.2031C20.6472 28.2031 21.1719 28.7277 21.1719 29.375C21.1719 30.0222 20.6472 30.5469 20 30.5469ZM21.1719 24.6875C21.1719 25.3352 20.6477 25.8594 20 25.8594C19.3523 25.8594 18.8281 25.3352 18.8281 24.6875V12.9688C18.8281 12.321 19.3523 11.7969 20 11.7969C20.6477 11.7969 21.1719 12.321 21.1719 12.9688V24.6875Z",
    fill: "#ED2E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.968aa84642a3b4ebe326ea3b477b2e77.svg";
export { ForwardRef as ReactComponent };